import { render, staticRenderFns } from "./diagnosisDialog.vue?vue&type=template&id=17738756&scoped=true&"
import script from "./diagnosisDialog.vue?vue&type=script&lang=js&"
export * from "./diagnosisDialog.vue?vue&type=script&lang=js&"
import style0 from "./diagnosisDialog.vue?vue&type=style&index=0&lang=css&"
import style1 from "./diagnosisDialog.vue?vue&type=style&index=1&id=17738756&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17738756",
  null
  
)

export default component.exports